import * as React from "react";
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";

export class WPTR extends React.Component<WordpressRowProps, WordpressRowState> {
    static defaultProps: Partial<WordpressRowProps> = {};

    constructor(props: WordpressRowProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <tr>
                {this.props.WPTable.props.IsSelectable&&this.props.WPTable.Columns.length>0&&
                    <td style={{width:40,textAlign:"center"}}>
                        <input style={{margin:0}} type={'checkbox'} checked={this.IsRowSelected()} onChange={x=>this.ToggleSelection()}/>
                    </td>
                }
                {this.props.WPTable.Columns.map(column=>
                    <td style={{...column.props.styles,minWidth:column.props.Width}} key={column.props.PropertyName}>
                        {this.GenerateColumn(this.props.Data,column)}

                        {column.props.Actions.length>0&&
                        <div className={'row-actions'}>
                            {
                                column.props.Actions.map((action,index)=>
                                    <span key={action.Id} className={action.ClassName}>
                                                            <a href={'#'} onClick={e=>{e.preventDefault();this.props.WPTable.props.ActionClicked&&this.props.WPTable.props.ActionClicked(action.Id,this.props.Data)}}>{action.Title}</a>
                                        {index<column.props.Actions.length-1&&" | "}
                                                        </span>

                                )
                            }
                        </div>

                        }
                    </td>
                )}
            </tr>
        )
    }

    public IsRowSelected(){
        if(this.props.WPTable.props.IsSelectable==false)
            return false;

        if(typeof this.props.Data[this.props.WPTable.props.SelectedPropertyName]=='undefined')
            return false;

        return this.props.Data[this.props.WPTable.props.SelectedPropertyName];
    }

    private GenerateColumn(row: any, property: WPBasicColumn) {
        let value='';
        if(row[property.props.PropertyName]!=null)
            value=row[property.props.PropertyName];

        if(property.props.Formatter!=null)
            value=property.props.Formatter(value,property.props,row);

        if(property.props.children!=null)
            return (property.props as any).children(row,this);



        if(property.props.IsClickable)
        {
            return (
                <a href={'#'} className={property.props.IsPrimary?'row-title':''} onClick={e=>{e.preventDefault();this.props.WPTable.props.RowClicked&&this.props.WPTable.props.RowClicked(row)}}>
                    {value}
                </a>
            )
        }else
        {
            if(property.props.Raw)
                return <div dangerouslySetInnerHTML={{__html:value}}/>
            else
                return value;
        }

    }

    private ToggleSelection() {
        this.props.Data[this.props.WPTable.props.SelectedPropertyName]=!this.IsRowSelected();
        this.forceUpdate();
        this.props.SelectionChanged&&this.props.SelectionChanged();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WordpressRowProps {
 WPTable:WPTable;
 Data:any;
 Index:number;
 SelectionChanged:()=>void;
}

interface WordpressRowState {

}

//#endregion "My Region"